const WORD_BANK = {
  "Science": [
    { word: "gravity", concept: "Force that pulls things down" },
    { word: "friction", concept: "Resistance when surfaces rub" },
    { word: "magnet", concept: "Attracts iron and steel" },
    { word: "energy", concept: "Power to do work or move" },
    { word: "habitat", concept: "Natural home of an animal" },
    { word: "atom", concept: "Tiny building block of matter" },
    { word: "proton", concept: "Positive particle in nucleus" },
    { word: "oxygen", concept: "Gas we breathe to live" },
    { word: "carbon", concept: "Element in all living things" },
    { word: "prism", concept: "Splits white light into colors" },
    { word: "volume", concept: "How much space something fills" },
    { word: "fossil", concept: "Remains of ancient life in rock" },
    { word: "mineral", concept: "Natural solid found in earth" },
    { word: "crystal", concept: "Solid with atoms in neat rows" },
    { word: "circuit", concept: "Path electricity flows through" },
    { word: "density", concept: "How heavy something is for its size" },
    { word: "erosion", concept: "Wind or water wearing away land" },
    { word: "neutron", concept: "Neutral particle in nucleus" },
    { word: "nucleus", concept: "Center of an atom or cell" },
    { word: "vitamin", concept: "Nutrient your body needs daily" },
    { word: "protein", concept: "Body-building nutrient in food" },
    { word: "vaccine", concept: "Shot that prevents disease" },
    { word: "eclipse", concept: "Moon or Sun gets blocked" },
    { word: "species", concept: "A group of similar living things" },
    { word: "climate", concept: "Weather pattern over many years" },
    { word: "cell", concept: "Basic unit of all living things" },
    { word: "force", concept: "Push or pull that moves things" },
    { word: "lens", concept: "Curved glass that bends light" },
    { word: "wave", concept: "Energy moving through space" },
    { word: "pulse", concept: "Rhythmic beat of blood flow" },
    { word: "alloy", concept: "Mixture of two or more metals" },
    { word: "orbit", concept: "Path a planet takes around a star" },
    { word: "nerve", concept: "Fiber that carries signals in body" },
    { word: "fungi", concept: "Living things like mushrooms and mold" },
    { word: "vapor", concept: "Gas form of a liquid like steam" },
    { word: "lever", concept: "Simple machine that lifts heavy loads" },
    { word: "scale", concept: "Tool used to measure weight" },
    { word: "fibre", concept: "Thread-like material in food or cloth" },
    { word: "gland", concept: "Organ that makes hormones or fluids" },
    { word: "plant", concept: "Living thing that makes its own food" },
    { word: "coral", concept: "Tiny sea creatures that build reefs" },
  ],
  "Mathematics": [
    { word: "decimal", concept: "Number with a dot like 3.5" },
    { word: "ratio", concept: "Compares two quantities" },
    { word: "angle", concept: "Space between two meeting lines" },
    { word: "sphere", concept: "Round 3D shape like a ball" },
    { word: "radius", concept: "Distance from center to edge" },
    { word: "median", concept: "Middle value in a sorted list" },
    { word: "factor", concept: "Number that divides evenly" },
    { word: "prime", concept: "Divisible only by 1 and itself" },
    { word: "square", concept: "Shape with 4 equal sides" },
    { word: "graph", concept: "Picture that shows data" },
    { word: "digit", concept: "Single number from 0 to 9" },
    { word: "sum", concept: "Result of adding numbers" },
    { word: "area", concept: "Space inside a flat shape" },
    { word: "cube", concept: "3D shape with 6 equal faces" },
    { word: "cone", concept: "Shape with round base and point" },
    { word: "profit", concept: "Money earned after costs" },
    { word: "minus", concept: "Take away or subtract" },
    { word: "tally", concept: "Marks used to count things" },
    { word: "chord", concept: "Line connecting two points on a circle" },
    { word: "axes", concept: "Reference lines on a graph — X and Y" },
    { word: "data", concept: "Numbers or facts collected for study" },
    { word: "mean", concept: "Average — add all and divide by count" },
    { word: "mode", concept: "Number that appears most often" },
    { word: "table", concept: "Rows and columns showing information" },
    { word: "place", concept: "Position of a digit — ones, tens, hundreds" },
    { word: "even", concept: "Number divisible by 2 — like 4, 6, 8" },
    { word: "line", concept: "Straight path going on forever" },
    { word: "point", concept: "An exact spot with no size" },
    { word: "solid", concept: "3D shape you can hold" },
    { word: "chart", concept: "Picture that shows data visually" },
    { word: "value", concept: "How much a number is worth" },
  ],
  "Social Science": [
    { word: "empire", concept: "Large area ruled by one leader" },
    { word: "colony", concept: "Land controlled by another country" },
    { word: "treaty", concept: "Agreement between countries" },
    { word: "revolt", concept: "People rising against rulers" },
    { word: "census", concept: "Counting all people in a country" },
    { word: "trade", concept: "Buying and selling of goods" },
    { word: "border", concept: "Line separating two countries" },
    { word: "desert", concept: "Dry land with very little rain" },
    { word: "island", concept: "Land surrounded by water" },
    { word: "delta", concept: "Triangle of land at river mouth" },
    { word: "valley", concept: "Low land between two hills" },
    { word: "tribe", concept: "Group of people with shared customs" },
    { word: "fossil", concept: "Clue about life long ago" },
    { word: "ballot", concept: "Paper used to cast a vote" },
    { word: "tax", concept: "Money paid to the government" },
    { word: "court", concept: "Place where judges decide cases" },
    { word: "realm", concept: "A kingdom or area of rule" },
    { word: "siege", concept: "Surrounding a fort to capture it" },
    { word: "exile", concept: "Forced to live away from homeland" },
    { word: "guild", concept: "Group of craftsmen working together" },
    { word: "caste", concept: "Social group determined by birth" },
    { word: "spice", concept: "Flavoring that India was famous for trading" },
    { word: "route", concept: "Path taken for travel or trade" },
    { word: "canal", concept: "Man-made waterway for boats or irrigation" },
    { word: "coast", concept: "Land along the edge of the sea" },
    { word: "urban", concept: "Relating to cities and towns" },
    { word: "rural", concept: "Relating to villages and countryside" },
    { word: "reign", concept: "Period when a king or queen rules" },
  ],
  "Social Studies": [
    { word: "rights", concept: "Freedoms every person deserves" },
    { word: "vote", concept: "Choose a leader by ballot" },
    { word: "flag", concept: "Symbol representing a country" },
    { word: "peace", concept: "No war or conflict" },
    { word: "colony", concept: "Land ruled by a foreign power" },
    { word: "ruler", concept: "Person who governs a kingdom" },
    { word: "temple", concept: "Place of worship and prayer" },
    { word: "market", concept: "Place where goods are sold" },
    { word: "harbor", concept: "Sheltered water for ships" },
    { word: "fort", concept: "Strong building for defense" },
    { word: "army", concept: "Organized group of soldiers" },
    { word: "chief", concept: "Leader of a tribe or group" },
    { word: "queen", concept: "Female ruler of a kingdom" },
    { word: "moat", concept: "Water-filled ditch around a fort" },
    { word: "trade", concept: "Buying and selling goods" },
    { word: "feast", concept: "Large celebratory meal" },
    { word: "craft", concept: "Skilled work done by hand" },
    { word: "myth", concept: "Ancient story explaining nature or gods" },
    { word: "coins", concept: "Metal money used for trade" },
  ],
  "English": [
    { word: "simile", concept: "Compares using 'like' or 'as'" },
    { word: "vowel", concept: "A, E, I, O, U sounds" },
    { word: "noun", concept: "Word for a person, place, thing" },
    { word: "verb", concept: "Action word like run or eat" },
    { word: "tense", concept: "Tells when an action happens" },
    { word: "plural", concept: "More than one of something" },
    { word: "prefix", concept: "Letters added before a word" },
    { word: "suffix", concept: "Letters added after a word" },
    { word: "rhyme", concept: "Words that end with same sound" },
    { word: "stanza", concept: "Group of lines in a poem" },
    { word: "clause", concept: "Part of a sentence with a verb" },
    { word: "essay", concept: "Short piece of writing on a topic" },
    { word: "comma", concept: "Punctuation mark for a pause" },
    { word: "fable", concept: "Story with a moral lesson" },
    { word: "genre", concept: "Type or category of writing" },
    { word: "draft", concept: "First rough version of writing" },
    { word: "prose", concept: "Normal written language — not poetry" },
    { word: "irony", concept: "Saying opposite of what you mean" },
    { word: "theme", concept: "Main message or idea in a story" },
    { word: "plot", concept: "Sequence of events in a story" },
    { word: "tone", concept: "Mood or feeling in writing" },
    { word: "lyric", concept: "Words of a song" },
    { word: "quote", concept: "Someone's exact words repeated" },
    { word: "moral", concept: "Lesson learned from a story" },
    { word: "diary", concept: "Book where you write daily thoughts" },
    { word: "title", concept: "Name given to a book or chapter" },
    { word: "scene", concept: "Part of a play happening in one place" },
  ],
  "EVS": [
    { word: "recycle", concept: "Turn waste into something new" },
    { word: "compost", concept: "Rotted plants that feed soil" },
    { word: "erosion", concept: "Soil washed away by water" },
    { word: "climate", concept: "Usual weather of a place" },
    { word: "season", concept: "Summer, winter, rainy, spring" },
    { word: "harvest", concept: "Picking crops when they are ready" },
    { word: "solar", concept: "Energy that comes from the Sun" },
    { word: "forest", concept: "Large area covered with trees" },
    { word: "pond", concept: "Small body of still water" },
    { word: "soil", concept: "Top layer of earth where plants grow" },
    { word: "nest", concept: "Home a bird builds for eggs" },
    { word: "roots", concept: "Parts of a plant under the soil" },
    { word: "seeds", concept: "Tiny things that grow into plants" },
    { word: "germs", concept: "Tiny things that can make you sick" },
    { word: "cloud", concept: "White fluffy mass in the sky" },
    { word: "river", concept: "Large flowing body of fresh water" },
    { word: "ocean", concept: "Huge body of salty water" },
    { word: "tribe", concept: "Community with shared traditions" },
    { word: "grain", concept: "Small hard seed like rice or wheat" },
    { word: "dairy", concept: "Products made from milk" },
    { word: "flora", concept: "All the plants in an area" },
    { word: "fauna", concept: "All the animals in an area" },
    { word: "waste", concept: "Things thrown away as garbage" },
    { word: "ozone", concept: "Gas layer protecting Earth from UV rays" },
    { word: "steam", concept: "Water turned into hot gas" },
  ]
};

// Pick N random words from subject, excluding any that appear in the topic itself
export function getScrambleWords(subject, topicText, count = 8) {
  const subjectWords = WORD_BANK[subject] || WORD_BANK["Science"];
  const topicLower = (topicText || "").toLowerCase();

  // Filter out words already in the topic (don't scramble what they just typed)
  const eligible = subjectWords.filter(entry => !topicLower.includes(entry.word) && entry.word.length <= 7);

  // Shuffle and pick
  const shuffled = [...eligible].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

// Scramble a word (ensure it's different from original)
export function scrambleWord(input) {
  const word = typeof input === "object" ? input.word : input;
  const letters = word.split("");
  let scrambled;
  let attempts = 0;
  do {
    scrambled = [...letters].sort(() => Math.random() - 0.5).join("");
    attempts++;
  } while (scrambled === word && attempts < 10);
  return scrambled.toUpperCase();
}

// Detect subject from topic text when subject prop isn't available
export function detectSubjectFromTopic(topicText) {
  const t = (topicText || "").toLowerCase();

  const mathWords = ["fraction", "ratio", "percentage", "number", "angle", "triangle", "circle", "algebra", "geometry", "equation", "multiply", "divide", "add", "subtract", "decimal", "math"];
  const socialWords = ["democracy", "constitution", "mughal", "empire", "parliament", "river", "climate", "continent", "independence", "history", "geography", "government", "president", "king"];
  const englishWords = ["grammar", "noun", "verb", "tense", "poem", "story", "essay", "letter", "adjective", "pronoun", "sentence", "paragraph"];
  const evsWords = ["plant", "animal", "water", "air", "food", "shelter", "weather", "season", "recycle", "pollution", "environment"];

  if (mathWords.some(w => t.includes(w))) return "Mathematics";
  if (socialWords.some(w => t.includes(w))) return "Social Science";
  if (englishWords.some(w => t.includes(w))) return "English";
  if (evsWords.some(w => t.includes(w))) return "EVS";
  return "Science";
}

export default WORD_BANK;
